import * as React from 'react';
import { SignUp } from 'aws-amplify-react';

import { PasswordRequirements } from './password-requirements';
import { withSectionBodyNotes } from './section-body-notes';
import { renderStockScreen } from './stock-screen';

// Notes injected directly beneath the sign-up field of the matching key. The
// keys are the `signUpFields` keys configured in SecureApp.tsx — `username` is
// the Email field, which doubles as the Cognito username.
const FIELD_NOTES: { [key: string]: React.ReactNode } = {
  username: (
    <div className="ls-auth-hint ls-auth-field-note" key="ls-username-note">
      This email address is also the username for signing in, and it is{' '}
      <strong>case-sensitive</strong> — it will have to be entered exactly as it is typed here.
    </div>
  ),
  password: <PasswordRequirements className="ls-auth-field-note" key="ls-password-requirements" />,
};

/**
 * The stock Amplify v3 SignUp screen, plus the account guidance practitioners
 * need while they are creating the account: that the email address becomes
 * their case-sensitive username, and what the password policy is.
 */
export class LabSmartsSignUp extends SignUp {
  showComponent(theme: any): React.ReactNode {
    return withSectionBodyNotes(
      renderStockScreen(this, SignUp, () => super.showComponent(theme)),
      'sign-up-body-section',
      fields => {
        // The base render emits exactly one element per configured field, in
        // the order `sortFields()` left them.
        if (fields.length !== this.signUpFields.length) {
          return null;
        }

        const annotated: React.ReactNode[] = [];
        this.signUpFields.forEach((field, index) => {
          annotated.push(fields[index]);
          const note = FIELD_NOTES[field.key];
          if (note) {
            annotated.push(note);
          }
        });
        return annotated;
      },
    );
  }
}
